import type { AppRouter } from '@app/api'
import {
  createTRPCClient,
  httpBatchLink,
  httpBatchStreamLink,
  splitLink,
} from '@trpc/client'
import superjson from 'superjson'

export const trpcClient = createTRPCClient<AppRouter>({
  links: [
    // Only the assistant streams. Its turns take seconds and should fill the
    // panel as they arrive; everything else is a request and a response, and
    // switching the whole app's transport for one feature would put every
    // other screen on a path it has no need for.
    splitLink({
      condition: (op) => op.path.startsWith('agent.'),
      true: httpBatchStreamLink({
        url: '/api/trpc',
        transformer: superjson,
        fetch: (url, options) =>
          fetch(url, { ...options, credentials: 'include' }),
      }),
      false: httpBatchLink({
        url: '/api/trpc',
        transformer: superjson,
        // Send the session cookie on every call (same-origin, httpOnly).
        fetch: (url, options) =>
          fetch(url, { ...options, credentials: 'include' }),
      }),
    }),
  ],
})
